<template>
  <el-dialog
    v-model="visible"
    width="400px"
    transition="dialog-bounce"
    :show-close="false"
    align-center
    lock-scroll
    :close-on-click-modal="false"
  >
    <template #header="{ close }">
      <div class="dialog-header">
        <el-icon :size="20" @click="close" class="close-btn">
          <Close />
        </el-icon>
        <h2>请选择支付方式</h2>
      </div>
    </template>
    <div class="address-info-footer">
      <el-radio-group v-model="paymentMethod">
<!--        <el-radio size="large" label="wepay">-->
<!--          <div class="payment-option">-->
<!--            <img src="@/assets/svgs/wepay.svg" alt="微信支付" class="payment-icon" />-->
<!--            <span>微信支付</span>-->
<!--          </div>-->
<!--        </el-radio>-->
        <el-radio size="large" label="alipay">
          <div class="payment-option">
            <img src="@/assets/svgs/alipay.svg" alt="支付宝支付" class="payment-icon" />
            <span>支付宝支付</span>
          </div>
        </el-radio>
      </el-radio-group>
      <el-button @click="submitOrder" size="large" color="#007c4f" type="primary" round>
        提交订单
      </el-button>
    </div></el-dialog
  >
</template>

<script setup>
  import { ref, unref, defineExpose, defineEmits } from 'vue'

  const emits = defineEmits(['confirm'])

  const visible = ref(false)
  const paymentMethod = ref('alipay')
  const submitOrder = () => {
    emits('confirm', unref(paymentMethod))
  }

  const show = () => (visible.value = true)

  defineExpose({ show })
</script>

<style lang="scss" scoped>
  .dialog-header {
    position: relative;

    h2 {
      font-size: 20px;
      font-weight: 700;
      text-align: center;
    }

    .close-btn {
      position: absolute;
      right: 0;
      cursor: pointer;
    }
  }

  .address-info-footer {
    display: flex;
    flex-direction: column;
    padding: 20px;
    gap: 10px;
    font-size: 20px;
    font-weight: 600;
    color: #333;

    :deep(.el-radio-group) {
      flex-direction: column;
      align-items: flex-start;

      .el-radio__inner {
        width: 24px;
        height: 24px;

        &::after {
          width: 10px;
          height: 10px;
        }
      }

      .el-radio__label {
        font-size: 18px;
      }

      .is-checked {
        .el-radio__label {
          color: #007c4f;
        }

        .el-radio__inner {
          background-color: #007c4f;
          border-color: #007c4f;
        }
      }

      .payment-option {
        display: flex;
        align-items: center;
        gap: 12px;

        .payment-icon {
          width: 22px;
          height: 22px;
          flex-shrink: 0;
        }

        span {
          font-size: 16px;
          color: #333;
          font-weight: 500;
        }
      }
    }
  }
</style>
